import { render } from "./CreateForm.vue?vue&type=template&id=2d7f033e&scoped=true"
import script from "./CreateForm.vue?vue&type=script&lang=js"
export * from "./CreateForm.vue?vue&type=script&lang=js"

import "./CreateForm.vue?vue&type=style&index=0&id=2d7f033e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d7f033e"]])

export default __exports__